<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Appetizers">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e93" xmlns:saxon="http://icl.com/saxon">Appetizers </a></h1><a id="d0e93" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e93" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e93" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e93" xmlns:saxon="http://icl.com/saxon">
</a><h2 class="nodivide"><a id="d0e93" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e96" xmlns:saxon="http://icl.com/saxon">Turkey Empanadas </a></h2><a id="d0e96" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td> 1 pound ground turkey </td>
</tr>
<tr>
<td>1 large onion, diced </td>
</tr>
<tr>
<td>1 can (8 ounces) tomato sauce </td>
</tr>
<tr>
<td>4 teaspoons Cajun seasoning mix </td>
</tr>
<tr>
<td>salt and pepper </td>
</tr>
<tr>
<td>1/2 cup grated Monterey Jack cheese </td>
</tr>
<tr>
<td>3 cans (7 ounce each) biscuits </td>
</tr>
<tr>
<td>1 egg, beaten </td>
</tr>
<tr>
<td>oil, for deep frying </td>
</tr>
</tbody></table>
<p>Saute turkey in large frying pan over medium heat until brown, breaking up meat with fork,
        about 5 minutes. Using slotted spoon, transfer turkey to small bowl. Add onion to drippings
        in frying pan and saute until light brown, about 7 minutes. Return turkey and any juices to
        frying pan. Add tomato sauce and Cajun seasoning; simmer until mixture is almost dry,
        stirring occasionally, about 8 minutes. Season with salt and pepper. Cool completely. Mix in
        cheese. </p>
<p>Flatten each biscuit into a 4-inch round. Place 1 tablespoon filling on round. Brush half
        of dough edge with egg. Fold dough over filling to create half circle and seal edges by
        pressing with tines of fork. Set empanada on baking sheet and cover with damp paper towel.
        Repeat with remaining biscuits and filling. </p>
<p>Pour oil to depth of 1/2 inch into heavy large frying pan. Heat oil over medium-high heat
        to 350 degrees. Fry empanadas in batches until golden brown, about 2 minutes per side.
        Transfer to a plate covered with paper towels. Serve warm or at room temperature. Makes 30
        empanadas. </p>
</a><h2><a id="d0e96" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e123" xmlns:saxon="http://icl.com/saxon">Wrapped Smokies with Mustard Sauce </a></h2><a id="d0e123" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 can (12 ounces) biscuits </td>
</tr>
<tr>
<td>10 little smoked sausages </td>
</tr>
<tr>
<td>2 tablespoons sugar </td>
</tr>
<tr>
<td>1 tablespoon dry mustard </td>
</tr>
<tr>
<td>2 tablespoons cornstarch </td>
</tr>
<tr>
<td>1/2 tablespoon garlic powder </td>
</tr>
<tr>
<td>1/2 tablespoon onion powder </td>
</tr>
<tr>
<td>1 can beer </td>
</tr>
<tr>
<td>1 tablespoon red wine vinegar </td>
</tr>
</tbody></table>
<p>Preheat oven to 400 degrees. </p>
<p>Flatten each biscuit into a 6-inch round. Quarter biscuits and wrap around uncooked
        wieners. Roll and seal the edges, completely covering the wiener. Place on lightly greased
        baking sheet and bake for 10 minutes or until dough is golden brown. </p>
<p>In a medium saucepan, combine sugar, mustard, cornstarch, garlic powder, and onion powder.
        Cook on low heat until mixture combines, stirring constantly, about 1 minute. Add in beer
        and vinegar. Cook over medium heat, stirring constantly, until thickened. Serve as dipping
        sauce. Makes 10 servings. </p>
</a><h2><a id="d0e123" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e150" xmlns:saxon="http://icl.com/saxon">Spinach Artichoke Dip in Bread Bowls </a></h2><a id="d0e150" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 package (8 ounces) cream cheese </td>
</tr>
<tr>
<td>1/2 cup mayonnaise </td>
</tr>
<tr>
<td>2 packages (9 ounces each) frozen creamed spinach, thawed </td>
</tr>
<tr>
<td>1 can (14 ounces) artichoke hearts, drained and chopped </td>
</tr>
<tr>
<td>1/2 cup grated Parmesan cheese </td>
</tr>
<tr>
<td>1/3 cup chopped onion </td>
</tr>
<tr>
<td>1/8 teaspoon cayenne pepper </td>
</tr>
<tr>
<td>2 cans (16.3 ounces each) biscuits </td>
</tr>
<tr>
<td>1/3 cup crushed herbed stuffing </td>
</tr>
<tr>
<td>1/2 cup chopped pecans </td>
</tr>
</tbody></table>
<p>Preheat oven to 375 degrees. Grease 16 muffin cups. </p>
<p>Combine cream cheese and mayonnaise in a large bowl. Stir in creamed spinach, artichokes,
        Parmesan cheese, onion, and pepper. </p>
<p>Flatten each biscuit into a 6-inch round. Place in muffin cups, pressing firmly into the
        bottom and up the sides of cup. Spoon dip evenly into each cup. Combine stuffing and pecans;
        sprinkle on top. Bake for 17–20 minutes or until biscuits are golden brown. Makes 16
        servings. </p>
</a><h2><a id="d0e150" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e179" xmlns:saxon="http://icl.com/saxon">Meatball Puffs </a></h2><a id="d0e179" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 cans (16.3 ounces each) biscuits </td>
</tr>
<tr>
<td>16 frozen Italian meatballs, thawed </td>
</tr>
<tr>
<td>2/3 cup grated mozzarella cheese </td>
</tr>
<tr>
<td>1 cup marinara sauce </td>
</tr>
</tbody></table>
<p>Preheat oven to 375 degrees. </p>
<p>Flatten each biscuit into a 5-inch round. Sprinkle with cheese and place a meatball in the
        center. Wrap dough around the meatball and pinch to seal. Place, pinched side down, on a
        slightly greased baking sheet. Bake for 17–20 minutes or until biscuits are golden brown.
        Serve warm with marinara sauce for dipping. Makes 16 servings. </p>
</a><h2><a id="d0e179" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e194" xmlns:saxon="http://icl.com/saxon">Tasty Flowers </a></h2><a id="d0e194" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1/4 cup preserves, flavor of choice </td>
</tr>
<tr>
<td>1/4 cup cream cheese </td>
</tr>
<tr>
<td>1 can (12 ounces) biscuits </td>
</tr>
</tbody></table>
<p>Preheat oven according to package directions. </p>
<p>In a medium bowl blend preserves and cream cheese. Place biscuits on a lightly greased
        baking sheet. Make five slashes on each biscuit to form the petals. Make an indentation in
        the center of the biscuit and drop in a teaspoon of cream cheese mixture. </p>
<p>Bake according to package directions. Makes 10 servings. </p>
</a><h2><a id="d0e194" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e209" xmlns:saxon="http://icl.com/saxon">Chicken and Dumplings </a></h2><a id="d0e209" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>3 cans (15 ounces each) chunky home-style chicken noodle soup </td>
</tr>
<tr>
<td>1 can (14 ounces) chicken or vegetable broth </td>
</tr>
<tr>
<td>1 can (12 ounces) biscuits </td>
</tr>
</tbody></table>
<p>Combine soups in large pot and bring to a boil. </p>
<p>Cut each biscuit into fourths. Drop biscuits into boiling soup and cook uncovered for 10
        minutes at a medium boil. Cover and continue to cook for another 10 minutes until biscuits
        are fluffy. Makes 8 servings. </p>
</a><h2><a id="d0e209" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e222" xmlns:saxon="http://icl.com/saxon">Cheese Balls </a></h2><a id="d0e222" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 can (12 ounces) biscuits </td>
</tr>
<tr>
<td>6 ounces cheddar cheese, cut into 40 cubes </td>
</tr>
<tr>
<td>1/4 cup crushed cornflakes </td>
</tr>
<tr>
<td>1/4 cup grated Parmesan cheese </td>
</tr>
<tr>
<td>1/4 teaspoon garlic powder </td>
</tr>
<tr>
<td>1/3 cup butter, melted </td>
</tr>
</tbody></table>
<p>Preheat oven to 400 degrees. </p>
<p>Cut each biscuit into fourths. Flatten each piece and place a cheese cube in to center.
        Wrap dough around cheese and seal with a pinch. Shape into a ball. </p>
<p>Combine cornflakes, cheese, and garlic powder. Roll each ball in butter then in cornflake
        mixture. Place on a lightly greased baking sheet. Bake for 7–9 minutes or until golden
        brown. Serve hot. Makes 40 balls. </p>
</a><h2><a id="d0e222" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e243" xmlns:saxon="http://icl.com/saxon">Shrimp and Pork Pot Stickers </a></h2><a id="d0e243" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1/4 pound ground pork </td>
</tr>
<tr>
<td>1 can water chestnuts, drained and diced </td>
</tr>
<tr>
<td>1/2 pound shrimp, peeled, deveined, and coarsely chopped </td>
</tr>
<tr>
<td>3/4 cup chopped scallions </td>
</tr>
<tr>
<td>1-1/2 tablespoons soy sauce </td>
</tr>
<tr>
<td>2 teaspoons minced fresh ginger </td>
</tr>
<tr>
<td>1 teaspoon Asian sesame oil </td>
</tr>
<tr>
<td>1 can (12 ounces) flaky biscuits </td>
</tr>
<tr>
<td>1/3 cup soy sauce </td>
</tr>
<tr>
<td>2 tablespoons Chinese vinegar </td>
</tr>
<tr>
<td>2 tablespoons water </td>
</tr>
<tr>
<td>1 teaspoon Asian chile oil </td>
</tr>
<tr>
<td>1/4 cup peanut oil </td>
</tr>
</tbody></table>
<p>In a medium frying pan, brown pork, stirring frequently to ensure pork is broken up into
        small pieces. Drain. In a large bowl, combine pork, chestnuts, shrimp, scallions, 1-1/2
        tablespoons soy sauce, ginger, and sesame oil. Mix well. </p>
<p>Split biscuits in half by pulling apart at center layers. On a floured surface and using a
        floured rolling pin, flatten biscuits into 4-inch rounds. Cut each biscuit in half. Place a
        tablespoon of pork mixture on each half. Moisten edges with water and fold dough over
        mixture. Seal edges firmly with a fork. In a medium bowl, combine 1/3 cup soy sauce,
        vinegar, water, and chile oil to make dipping sauce. </p>
<p>Place peanut oil in a medium frying pan. Over medium heat, fry biscuits until lightly
        brown. Serve pot stickers warm with soy dipping sauce. Makes 40 pot stickers. </p>
</a><h2><a id="d0e243" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e278" xmlns:saxon="http://icl.com/saxon">Cocktail Biscuits </a></h2><a id="d0e278" xmlns:saxon="http://icl.com/saxon">
</a><h4><a id="d0e278" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e280" xmlns:saxon="http://icl.com/saxon">Cream Cheese Spread:</a></h4><a id="d0e280" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 package (8 ounces) cream cheese </td>
</tr>
<tr>
<td>1-1/2 tablespoons half-and-half </td>
</tr>
<tr>
<td>1 teaspoon dill weed </td>
</tr>
<tr>
<td>1 clove garlic, finely chopped </td>
</tr>
<tr>
<td>3/4 teaspoon chives </td>
</tr>
<tr>
<td>1/8 teaspoon hot sauce </td>
</tr>
<tr>
<td>1/8 teaspoon pepper </td>
</tr>
<tr>
<td>1/4 teaspoon salt </td>
</tr>
</tbody></table>
</a><h4><a id="d0e280" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e299" xmlns:saxon="http://icl.com/saxon">Biscuits:</a></h4><a id="d0e299" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 teaspoons butter </td>
</tr>
<tr>
<td>1 cup minced mushrooms </td>
</tr>
<tr>
<td>2 shallots, minced </td>
</tr>
<tr>
<td>1/2 cup finely chopped ham </td>
</tr>
<tr>
<td>2 green onions, finely chopped </td>
</tr>
<tr>
<td>pepper, to taste </td>
</tr>
<tr>
<td>1 can (12 ounces) biscuits </td>
</tr>
</tbody></table>
<p>In a large bowl, combine cream cheese and half-and-half; mix well. Add rest of ingredients
        for cream cheese spread and mix well. Place in refrigerator and chill overnight. </p>
<p>Preheat oven to 400 degrees. </p>
<p>In medium frying pan, melt butter and then saute mushrooms and shallots until tender. Add
        ham, onions, and pepper. Cook for 4 minutes. Remove from heat. Press each biscuit firmly
        into mushroom mixture coating the entire top of biscuit. Place on a lightly greased baking
        sheet. Make an indentation in each biscuit by pressing a tablespoon firmly in the center.
        Bake for 12–15 minutes. Top with cream cheese mixture. Makes 10 servings. </p>
</a><h2><a id="d0e299" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e322" xmlns:saxon="http://icl.com/saxon">Zucchini and Cheese Roll-Ups </a></h2><a id="d0e322" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 cup chopped zucchini </td>
</tr>
<tr>
<td>1/4 cup chopped onions </td>
</tr>
<tr>
<td>1 tablespoon butter </td>
</tr>
<tr>
<td>1/2 teaspoon dried dill weed </td>
</tr>
<tr>
<td>1/2 teaspoon basil </td>
</tr>
<tr>
<td>1 can (12 ounces) flaky biscuits </td>
</tr>
<tr>
<td>1 cup grated sharp cheddar cheese </td>
</tr>
</tbody></table>
<p>Preheat oven to 400 degrees. </p>
<p>In a large frying pan, saute zucchini and onion in butter until tender. Remove from heat
        and stir in dill weed and basil. </p>
<p>Sprinkle flour on a large surface. Using a floured rolling pin, flatten biscuits into
        5-inch rounds. Arrange biscuits so they are slightly over lapping, 2 across and 5 down.
        Flatten with the rolling pin to create a rectangle. Spread zucchini mixture evenly across
        biscuits and top with cheese. </p>
<p>Roll biscuits into a log beginning at the shortest edge and seal ends well. Cut into 10
        pieces and place, cut side down, on a lightly greased baking sheet. Bake 15–20 minutes,
        until golden brown. Serve immediately. Makes 10 servings. </p>
</a><h2><a id="d0e322" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e347" xmlns:saxon="http://icl.com/saxon">Bruschetta </a></h2><a id="d0e347" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 cup olive oil </td>
</tr>
<tr>
<td>1/2 cup balsamic vinegar </td>
</tr>
<tr>
<td>1 teaspoon basil </td>
</tr>
<tr>
<td>1 teaspoon Dijon mustard </td>
</tr>
<tr>
<td>1 clove garlic, minced </td>
</tr>
<tr>
<td>6 large tomatoes, sliced </td>
</tr>
<tr>
<td>12 ounces pesto </td>
</tr>
<tr>
<td>6 ounces fresh mozzarella, sliced </td>
</tr>
<tr>
<td>1 can (12 ounces) flaky biscuits </td>
</tr>
</tbody></table>
<p>Mix together oil, vinegar, basil, mustard, and garlic. Add tomatoes and place, covered, in
        refrigerator to marinate overnight. </p>
<p>Preheat oven to 400 degrees. </p>
<p>Cut biscuits in half horizontally. Flatten into 4-inch rounds and place on a greased baking
        sheet. Bake 10–15 minutes. Top each biscuit with pesto, tomato and mozzarella. Makes 20
        servings. </p>
</a><h2><a id="d0e347" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e374" xmlns:saxon="http://icl.com/saxon">Potato Turnovers </a></h2><a id="d0e374" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>6 large potatoes, peeled and cut in large pieces </td>
</tr>
<tr>
<td>3 large onions, finely diced </td>
</tr>
<tr>
<td>3 tablespoons butter </td>
</tr>
<tr>
<td>2 cups grated cheddar cheese </td>
</tr>
<tr>
<td>1 can (12 ounces) flaky biscuits </td>
</tr>
</tbody></table>
<p>In large pot, boil potatoes 20­–25 minutes until soft. Drain. </p>
<p>Preheat oven to 400 degrees. </p>
<p>In a large frying pan, saute onions in butter until clear. Combine potatoes, onions, and
        cheese. With a hand mixer, blend until creamy. </p>
<p>On a lightly floured surface, flatten biscuits into 7-inch rounds using a floured rolling
        pin. Place 1/2 cup potato mixture in the center of each biscuit. Moisten edges with water
        and fold into half circles. Use fork to seal edges. Bake for 15 minutes or until lightly
        golden. Makes 10 servings. </p>
</a><h2><a id="d0e374" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e395" xmlns:saxon="http://icl.com/saxon">Jalapeno Puffers </a></h2><a id="d0e395" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 can (12 ounces) biscuits </td>
</tr>
<tr>
<td>10 slices jalapeno </td>
</tr>
<tr>
<td>1/2 cup grated cheddar cheese </td>
</tr>
</tbody></table>
<p>Preheat oven to 375 degrees. </p>
<p>Flatten each biscuit into a 5-inch round. Place a slice of jalapeno and a large pinch of
        cheddar cheese in the center of each biscuit. Fold biscuit over and pinch to seal edges.
        Place seam down on a lightly greased baking sheet. Bake until golden brown, about 15
        minutes. Makes 10 servings. </p>
</a><h2><a id="d0e395" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e408" xmlns:saxon="http://icl.com/saxon">Cheese Crescents </a></h2><a id="d0e408" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 tablespoons butter </td>
</tr>
<tr>
<td>2 teaspoons garlic powder </td>
</tr>
<tr>
<td>1/2 cup grated sharp cheddar cheese </td>
</tr>
<tr>
<td>1/2 cup grated mozzarella </td>
</tr>
<tr>
<td>1 can (12 ounces) biscuits </td>
</tr>
</tbody></table>
<p>Preheat oven to 375 degrees. </p>
<p>Melt butter and add garlic powder. In a separate bowl, mix cheeses. </p>
<p>Flatten each biscuit into a 6-inch round and cut in half. Brush top of biscuit with garlic
        butter. Top with cheese blend. Beginning at the narrowest point, roll biscuit into a
        crescent. Drizzle butter over top. Place on a lightly greased baking sheet and bake for 15
        minutes. Makes 20 crescents. </p>
</a><h2><a id="d0e408" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e427" xmlns:saxon="http://icl.com/saxon">Pepperoni Bites </a></h2><a id="d0e427" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 cup grated mozzarella cheese </td>
</tr>
<tr>
<td>1/2 cup chopped pepperoni </td>
</tr>
<tr>
<td>1/2 cup pizza sauce </td>
</tr>
<tr>
<td>2 cans (7 ounces each)biscuits </td>
</tr>
<tr>
<td>1 tablespoon milk </td>
</tr>
<tr>
<td>1/4 cup grated Parmesan cheese </td>
</tr>
<tr>
<td>1 teaspoon oregano </td>
</tr>
<tr>
<td>1 teaspoon basil </td>
</tr>
</tbody></table>
<p>Preheat oven to 350 degrees. </p>
<p>In a bowl, combine mozzarella cheese, pepperoni, and sauce. Set aside. </p>
<p>Flatten each biscuit into a 3-inch round. Place about 1 rounded teaspoon filling in the
        center of each circle. Bring edges of dough together. Pinch to seal. Place, seam side down,
        on greased baking sheets. Brush with milk. Sprinkle with Parmesan cheese, oregano and basil.
        Bake for 12–15 minutes or until golden brown. Makes 20 pieces. </p>
</a><h2><a id="d0e427" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e452" xmlns:saxon="http://icl.com/saxon">Feta Biscuits </a></h2><a id="d0e452" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>3/4 cup crumbled feta cheese </td>
</tr>
<tr>
<td>1 tablespoon lemon juice </td>
</tr>
<tr>
<td>1 tablespoon dill </td>
</tr>
<tr>
<td>1 green onion, finely chopped </td>
</tr>
<tr>
<td>1 can (7 ounces) biscuits </td>
</tr>
<tr>
<td>10 green olives with pimientos </td>
</tr>
</tbody></table>
<p>Preheat oven to 400 degrees. </p>
<p>In small serving bowl, combine cheese, lemon juice, dill, and onion. </p>
<p>Lightly grease 10 muffin cups. Cut each biscuit in half horizontally and arrange 1 layer in
        bottom of each muffin cup. </p>
<p>Place cheese mixture evenly among cups. Place one olive in the center of each. Top with
        remaining biscuit layer; press around edge of each biscuit to seal. Bake 8–10 minutes or
        until biscuits are golden brown. Let biscuits cool before serving. Makes 10 servings. </p>
</a></div><a id="d0e452" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?37041948